'use client';

import { Box } from '@terra/ui-styled-system';
import {
  isPlainRecord,
  capBrowserAutomationScreenshotBase64,
} from '@terra/shared-dto-chat-types';
import { useTranslations } from 'next-intl';

export function readBrowserAutomationScreenshotBase64(
  output: unknown,
): string | undefined {
  if (!isPlainRecord(output)) {
    return undefined;
  }

  const data = output.data;
  if (!isPlainRecord(data)) {
    return undefined;
  }

  return typeof data.screenshotBase64 === 'string'
    ? capBrowserAutomationScreenshotBase64(data.screenshotBase64)
    : undefined;
}

type BrowserAutomationScreenshotPreviewProps = {
  screenshotBase64: string;
};

export function BrowserAutomationScreenshotPreview({
  screenshotBase64,
}: BrowserAutomationScreenshotPreviewProps) {
  const t = useTranslations('designSystem.chat.portalTools');

  return (
    <Box
      mt={2}
      borderRadius="md"
      overflow="hidden"
      borderWidth="1px"
      borderColor="border.neutral.muted"
      bg="bg.canvas"
    >
      <img
        src={`data:image/png;base64,${screenshotBase64}`}
        alt={t('browserScreenshotAlt')}
        style={{
          width: '100%',
          maxHeight: '240px',
          objectFit: 'contain',
          display: 'block',
        }}
      />
    </Box>
  );
}
